export enum SiteType {
  SHOP = 'SHOP',
  WAREHOUSE = 'WAREHOUSE',
  PICKUP_POINT = 'PICKUP_POINT',
  HOME_DELIVERY_ONLY = 'HOME_DELIVERY_ONLY',
}
